// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    font-family: 'Uniform', sans-serif;
}
.container1{
    width: calc(100vw-17rem);
    height: 100vh;
    background-color: #FAF9FF;
}
.dashboard-container{
    display: grid;
    grid-template-columns:  2fr 1fr 1fr;
    grid-template-rows: 1fr 5fr 6fr 8fr 33fr 11fr 6fr 33fr 6fr;
    gap: 10px;
    
    height: 100vh;
    /*width: calc(100vw-19rem);*/
}
.grid-empty1{
    grid-column: 1 /-1;
    grid-row: 1;
}
.dashboard-title{
    font-family: "Uniform", sans-serif;
    grid-column: 1 /-1;
    grid-row: 2;
    font-weight: bold;
    font-size: 36px;
    color: #000000;
}
.dashboard-welcome{
    grid-column: 1 /-1 ;
    grid-row: 3;
    font-family: "Uniform", sans-serif;
    font-size: 500;
    color: #737373;    

}
.grid-empty2{
    grid-column: 1 /-1;
    grid-row: 4;
}
.grid-first-cards{
    display: flex;
    width: 100%;
    gap: 10px;
    grid-row: 5;
}
.grid-empty3{
    grid-column: 1 /-1 ;
    grid-row: 6;
}
.grid-second-title{
    grid-column: 1 /-1 ;
    grid-row: 7;
    color: #000;
    font-size: 24;
    font-weight: bold;
    line-height: auto;
    text-align:start;
    text-align: left;
    height: 36;
}
.grid-second-cards{
    display: flex;
    gap: 10px;
    grid-row: 8;
}
.grid-item4{
    grid-column: 1;
    grid-row: 8;
}
.grid-item5{
    grid-column: 2;
    grid-row: 8;
}
.grid-item6{
    grid-column: 3;
    grid-row: 8;
}
.grid-empty4{
    grid-column: 1 /-1 ;
    grid-row: 9;
}

/**------------------BUILDING PERMIT STYLES START*/
.building-permit-form {
    padding: 20px;
    margin-left: 17rem;
  }
  
  .building-permit-form h1 {
    text-align: center;
    margin-bottom: 10px;
  }
  .building-permit-form input{
    width: 100%;
  }

  .tab-content {
    margin-top: 10px;
  }
  
  .building-permit-form .MuiTextField-root {
    margin-bottom: 5px;
  }
  
  .building-permit-form .MuiFormControl-root {
    margin-bottom: 5px;
  }
  
  .building-permit-form .MuiButton-contained {
    margin-top: 10px;
  }
  
  /* Responsive Styling */
  @media (max-width: 600px) {
    .building-permit-form .MuiGrid-container {
      flex-direction: column;
    }
  
    .building-permit-form .MuiGrid-item {
      margin-bottom: 15px;
    }
  }
  /**------------------BUILDING PERMIT STYLES END*/
/* Make the grid vertical when it starts to be covered */
@media (max-width: 768px) {
    .dashboard-container{
        grid-template-columns: 1fr;
        grid-template-rows: repeat(3, 1fr);
        grid-auto-flow: row;   
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/Views/LandInfraDevelopment/DesignAndConstructionView/DACDashboard.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;AACA;IACI,wBAAwB;IACxB,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mCAAmC;IACnC,0DAA0D;IAC1D,SAAS;;IAET,aAAa;IACb,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,kCAAkC;IAClC,cAAc;IACd,cAAc;;AAElB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;IACb,WAAW;IACX,SAAS;IACT,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,uBAAuB;EACvB;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,mBAAmB;IACrB;EACF;EACA,gDAAgD;AAClD,wDAAwD;AACxD;IACI;QACI,0BAA0B;QAC1B,kCAAkC;QAClC,mBAAmB;IACvB;EACF","sourcesContent":["*{\r\n    font-family: 'Uniform', sans-serif;\r\n}\r\n.container1{\r\n    width: calc(100vw-17rem);\r\n    height: 100vh;\r\n    background-color: #FAF9FF;\r\n}\r\n.dashboard-container{\r\n    display: grid;\r\n    grid-template-columns:  2fr 1fr 1fr;\r\n    grid-template-rows: 1fr 5fr 6fr 8fr 33fr 11fr 6fr 33fr 6fr;\r\n    gap: 10px;\r\n    \r\n    height: 100vh;\r\n    /*width: calc(100vw-19rem);*/\r\n}\r\n.grid-empty1{\r\n    grid-column: 1 /-1;\r\n    grid-row: 1;\r\n}\r\n.dashboard-title{\r\n    font-family: \"Uniform\", sans-serif;\r\n    grid-column: 1 /-1;\r\n    grid-row: 2;\r\n    font-weight: bold;\r\n    font-size: 36px;\r\n    color: #000000;\r\n}\r\n.dashboard-welcome{\r\n    grid-column: 1 /-1 ;\r\n    grid-row: 3;\r\n    font-family: \"Uniform\", sans-serif;\r\n    font-size: 500;\r\n    color: #737373;    \r\n\r\n}\r\n.grid-empty2{\r\n    grid-column: 1 /-1;\r\n    grid-row: 4;\r\n}\r\n.grid-first-cards{\r\n    display: flex;\r\n    width: 100%;\r\n    gap: 10px;\r\n    grid-row: 5;\r\n}\r\n.grid-empty3{\r\n    grid-column: 1 /-1 ;\r\n    grid-row: 6;\r\n}\r\n.grid-second-title{\r\n    grid-column: 1 /-1 ;\r\n    grid-row: 7;\r\n    color: #000;\r\n    font-size: 24;\r\n    font-weight: bold;\r\n    line-height: auto;\r\n    text-align:start;\r\n    text-align: left;\r\n    height: 36;\r\n}\r\n.grid-second-cards{\r\n    display: flex;\r\n    gap: 10px;\r\n    grid-row: 8;\r\n}\r\n.grid-item4{\r\n    grid-column: 1;\r\n    grid-row: 8;\r\n}\r\n.grid-item5{\r\n    grid-column: 2;\r\n    grid-row: 8;\r\n}\r\n.grid-item6{\r\n    grid-column: 3;\r\n    grid-row: 8;\r\n}\r\n.grid-empty4{\r\n    grid-column: 1 /-1 ;\r\n    grid-row: 9;\r\n}\r\n\r\n/**------------------BUILDING PERMIT STYLES START*/\r\n.building-permit-form {\r\n    padding: 20px;\r\n    margin-left: 17rem;\r\n  }\r\n  \r\n  .building-permit-form h1 {\r\n    text-align: center;\r\n    margin-bottom: 10px;\r\n  }\r\n  .building-permit-form input{\r\n    width: 100%;\r\n  }\r\n\r\n  .tab-content {\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .building-permit-form .MuiTextField-root {\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .building-permit-form .MuiFormControl-root {\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .building-permit-form .MuiButton-contained {\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  /* Responsive Styling */\r\n  @media (max-width: 600px) {\r\n    .building-permit-form .MuiGrid-container {\r\n      flex-direction: column;\r\n    }\r\n  \r\n    .building-permit-form .MuiGrid-item {\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n  /**------------------BUILDING PERMIT STYLES END*/\r\n/* Make the grid vertical when it starts to be covered */\r\n@media (max-width: 768px) {\r\n    .dashboard-container{\r\n        grid-template-columns: 1fr;\r\n        grid-template-rows: repeat(3, 1fr);\r\n        grid-auto-flow: row;   \r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
